import { z } from 'zod';

export const loginFormSchema = z.object({
  identifier: z.string().trim().min(1, 'Enter your username, email, or patient login ID').max(100),
  password: z.string().min(1, 'Enter your password').max(200),
  remember: z.boolean(),
});

export type LoginFormValues = z.infer<typeof loginFormSchema>;
